export default __webpack_public_path__ + "static/media/threat-intellgince.5a648b54.png";